import { createRouter, createWebHistory } from "vue-router";

const publicRoutes = [
  {
    path: "/viewing/transactions/:id",
    name: "public_transaction_view",
    component: () => import("@/pages/public/PublicTransactionView.vue"),
    meta: {
      title: "Просмотр транзакции",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    component: () => import("@/pages/auth/AuthRegistrationFlow.vue"),
    name: "auth",
    meta: {
      title: "Авторизация",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: publicRoutes,
});

export default router;
